// extracted by mini-css-extract-plugin
module.exports = {"frontWelcome":"HeaderMessage_frontWelcome__25E5R","welcomeHead":"HeaderMessage_welcomeHead__1Ztp5"};